import Icon from '@ant-design/icons'
import { UniqueIdentifier, useDraggable } from '@dnd-kit/core'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import styles from './form-item-draggable.module.scss'
import { getIcon, IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'
import { builderComponentConfigObjectFactory } from '../../utils/builder-component-config-factory'

type FormItemDraggableBaseProps = {
  id: UniqueIdentifier
  icon: IconEnum
  title: string
  type: FormItemType
}

export const FormItemDraggableBase = ({ id, icon, title, type }: FormItemDraggableBaseProps) => {
  const { t } = useTranslation()
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data: {
      id,
      type,
      icon,
      title,
      config: builderComponentConfigObjectFactory(type),
    },
  })

  const style = {
    cursor: 'grab',
  }

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={clsx(styles.draggableItem)}
      style={style}
    >
      <Icon
        className={clsx(styles.icon)}
        component={getIcon(icon)}
      />
      <span>{t(title)}</span>
    </div>
  )
}
